import { Globe, Users, UserCheck, UserPlus, Lock, Star } from "lucide-react";

// Lot 649 — audience d'une publication (façon Facebook) : qui peut la voir. Mémorisée comme choix par défaut
// (serveur : user.default_post_audience, miroir local pour l'instant d'après).
const KEY = "yalola.post.audience";
// Lot 655 — « Amis proches » : vert façon Instagram (anneau, étoile).
export const CLOSE_FRIENDS_COLOR = "#16a34a";

export const AUDIENCES = [
  { key: "public", icon: Globe, label: "Public", desc: "Tout le monde sur Yalola", tkey: "audience.public", dkey: "audience.public_desc" },
  { key: "followers", icon: Users, label: "Abonnés", desc: "Ceux qui te suivent", tkey: "audience.followers", dkey: "audience.followers_desc" },
  { key: "friends", icon: UserCheck, label: "Abonnés mutuels", desc: "Vous vous suivez l'un l'autre", tkey: "audience.friends", dkey: "audience.friends_desc" },
  { key: "following", icon: UserPlus, label: "Suivis", desc: "Ceux que tu suis", tkey: "audience.following", dkey: "audience.following_desc" },
  { key: "close_friends", icon: Star, label: "Amis proches", desc: "Seulement les personnes de ta liste Amis proches", tkey: "audience.close_friends", dkey: "audience.close_friends_desc", accent: CLOSE_FRIENDS_COLOR },
  { key: "private", icon: Lock, label: "Moi uniquement", desc: "Personne d'autre ne la voit", tkey: "audience.private", dkey: "audience.private_desc" },
];

export const audienceOf = (key) => AUDIENCES.find((a) => a.key === key) || AUDIENCES[0];
export const isRestrictedAudience = (key) => !!key && key !== "public" && key !== "group" && AUDIENCES.some((a) => a.key === key);
// Couleur d'accent d'une audience (vert « Amis proches », sinon la couleur primaire).
export const audienceAccent = (key) => audienceOf(key).accent || "var(--yalola-primary)";

export const readDefaultAudience = (user) => {
  try {
    const local = localStorage.getItem(KEY);
    if (local && AUDIENCES.some((a) => a.key === local)) return local;
  } catch { /* noop */ }
  return audienceOf(user?.default_post_audience).key;
};
export const writeDefaultAudience = (key) => { try { localStorage.setItem(KEY, audienceOf(key).key); } catch { /* noop */ } };

// Lot 651 — stories : mémoire séparée (serveur : user.default_story_audience, miroir local). Les stories d'église restent publiques.
const STORY_KEY = "yalola.story.audience";
export const readDefaultStoryAudience = (user) => {
  try {
    const local = localStorage.getItem(STORY_KEY);
    if (local && AUDIENCES.some((a) => a.key === local)) return local;
  } catch { /* noop */ }
  return audienceOf(user?.default_story_audience).key;
};
export const writeDefaultStoryAudience = (key) => { try { localStorage.setItem(STORY_KEY, audienceOf(key).key); } catch { /* noop */ } };
